import { showNotification } from 'Store/Notification/Notification.action';
import BrowserDatabase from 'Util/BrowserDatabase';
import { makeCancelable } from 'Util/Promise';
import { Field, prepareQuery } from 'Util/Query';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';
import { executePost, listenForBroadCast } from 'Util/Request/Request';

import FlexibleFormsQuery from '../../query/FlexibleForms.query';
import { updateFlexibleForms } from './FlexibleForms.action';

/** @namespace Scandiweb/Flexibleforms/Store/FlexibleForms/Dispatcher */
export class FlexibleFormsDispatcher {
    __construct() {
        this.name = 'FlexibleForms';
        this.promise = null;
    }

    /**
     * Overriden to use a POST (executePost) request instead of GET (executeGet)
     *
     * Is responsible for request routing and manages `onError`, `onSuccess`, `onUpdate` functions triggers.
     * @param  {Function} dispatch Store changing function from Redux (dispatches actions)
     * @param  {any} options Any options received from Container
     * @return {void}@memberof QueryDispatcher
     */
    handleData(dispatch, options) {
        const { name } = this;

        const rawQueries = this.prepareRequest(options, dispatch);

        if (!rawQueries) {
            return;
        }

        const queries = rawQueries instanceof Field ? [rawQueries] : rawQueries;

        if (this.promise) {
            this.promise.cancel();
        }

        this.promise = makeCancelable(
            new Promise((resolve, reject) => {
                executePost(prepareQuery(queries))
                    .then(
                        /** @namespace Scandiweb/Flexibleforms/Store/FlexibleForms/Dispatcher/FlexibleFormsDispatcher/handleData/makeCancelable/executePost/then/resolve */
                        (data) => resolve(data),
                        /** @namespace Scandiweb/Flexibleforms/Store/FlexibleForms/Dispatcher/FlexibleFormsDispatcher/handleData/makeCancelable/executePost/then/reject/catch */
                        (error) => reject(error)
                    );
            })
        );

        this.promise.promise.then(
            /** @namespace Scandiweb/Flexibleforms/Store/FlexibleForms/Dispatcher/FlexibleFormsDispatcher/handleData/then */
            (data) => this.onSuccess(data, dispatch, options),
            /** @namespace Scandiweb/Flexibleforms/Store/FlexibleForms/Dispatcher/FlexibleFormsDispatcher/handleData/then/catch */
            (error) => this.onError(error, dispatch, options),
        );

        listenForBroadCast(name).then(
            /** @namespace Scandiweb/Flexibleforms/Store/FlexibleForms/Dispatcher/FlexibleFormsDispatcher/handleData/listenForBroadCast/then */
            (data) => this.onUpdate(data, dispatch, options),
        );
    }

    onSuccess(data, dispatch) {
        if (data) {
            BrowserDatabase.setItem(data, 'FlexibleForms', ONE_MONTH_IN_SECONDS);
            dispatch(updateFlexibleForms(data));
        }
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', __('Error fetching FlexibleForms!'), error));
    }

    prepareRequest(form_id) {
        return [
            FlexibleFormsQuery.getFormQuery(form_id)
        ];
    }
}

export default new FlexibleFormsDispatcher();
